import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Contact from '../pages/contact/Contact'

export default function ContactRoutes() {
  return (
    <Routes>
        <Route path='/' element={<Contact />} />
    </Routes>
  )
}
